/** Rango/Ranger helpers — ported from Gereh without Redux. */

export function generateSocketURI(baseUrl, streams) {
  const list = (streams || []).filter(Boolean);
  const sorted = [...list].sort();
  return `${String(baseUrl).replace(/\/+$/, "")}/?stream=${sorted.join("&stream=")}`;
}

export const periodsMapNumber = {
  "1h": 60,
  "2h": 120,
  "4h": 240,
  "6h": 360,
  "12h": 720,
  "1d": 1440,
  "3d": 4320,
  "1w": 10080,
};

export const periodsMapString = {
  60: "1h",
  120: "2h",
  240: "4h",
  360: "6h",
  720: "12h",
  1440: "1d",
  4320: "3d",
  10080: "1w",
};

export function periodMinutesToString(period) {
  return periodsMapString[Number(period)] || periodsMapString[240];
}

export function periodStringToMinutes(period) {
  return periodsMapNumber[period] || 240;
}

export function marketKlineStream(marketId, periodString) {
  return `${marketId}.kline-${periodString}`;
}

export function marketPublicStreams(marketId, { incremental = true } = {}) {
  const id = String(marketId || "").toLowerCase();
  if (!id) return [];
  const depth = incremental ? `${id}.ob-inc` : `${id}.update`;
  return [`${id}.trades`, depth];
}

/** BTC-IRT | BTC_IRT → btcirt (fallback when catalog missing). */
export function shahooMarketToDenaId(marketKeyOrRoute) {
  const normalized = String(marketKeyOrRoute || "")
    .replace(/-/g, "_")
    .toUpperCase();
  const [base, quote] = normalized.split("_");
  if (!base || !quote) return null;
  return `${base.toLowerCase()}${quote.toLowerCase()}`;
}

export function resolveMarketId(routeOrKey, getMarketByRoute) {
  const route = String(routeOrKey || "").replace(/_/g, "-");
  const fromCatalog = getMarketByRoute?.(route);
  if (fromCatalog?.marketId) return String(fromCatalog.marketId).toLowerCase();
  return shahooMarketToDenaId(routeOrKey);
}

export function getRangerBaseUrl() {
  const fromEnv = window.env?.api?.rangerUrl;
  if (fromEnv) return String(fromEnv).replace(/\/+$/, "");

  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}/api/v2/ranger`;
}

export function isRangerEnabled() {
  const flag = process.env.REACT_APP_RANGER_ENABLED;
  if (flag === "false" || flag === "0") return false;
  if (flag === "true" || flag === "1") return true;
  return Boolean(window.env?.api?.rangerUrl || window.env?.rangerEnabled);
}

export function isRangerIncrementalOrderBook() {
  if (window.env?.incrementalOrderBook === false) return false;
  return true;
}
